import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/PhoneLogs';
import RegionCollection from './components/RegionalPhoneLogs';
import UserCollection from './components/UserPhoneLogs';
import Object from './components/PhoneLog';
import UserRoles from "constants/UserRoles";

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions, roles}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
			<ErrorBoundaryRoute path={`${match.url}/regions`}>
				<RegionCollection regions={regions} roles={roles} baseUrl={match.url}/>
			</ErrorBoundaryRoute>}

			{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
			<ErrorBoundaryRoute path={`${match.url}/users`}>
				<UserCollection regions={regions} roles={roles} baseUrl={match.url}/>
			</ErrorBoundaryRoute>}

			<ErrorBoundaryRoute path={`${match.url}/new`}>
				<Object regions={regions} baseUrl={match.url} isNew={true}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object regions={regions} baseUrl={match.url} isNew={false}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`} />
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
